module.exports = __webpack_public_path__ + "img/checkk.58565a07.png";